import { buildSelector } from '@/employees/components/Selector/utilities/builder/selectorBuilder'
export default {
  methods: {
    /**
     * @description This function will emit event to the selector builder
     * which signal it should add a certain property with an certain value to the selector that has this reference
     * @param {string} reference
     * @param {string} selectorPropertyEnum
     * @param {any} value
     * @returns {void}
     */
    selectorPropertyValueAdd (reference, selectorPropertyEnum, value) {
      this.$root.$emit('SelectorPropertyValueAdd', [reference, selectorPropertyEnum, value])
    },
    /**
     * @description This function will emit event to the selector builder
     * which signal it should update a certain property with an certain value to the selector that has this reference
     * @param {string} reference
     * @param {string} selectorPropertyEnum
     * @param {any} value
     * @returns {void}
     */
    selectorPropertyValueChange (reference, selectorPropertyEnum, value) {
      this.$root.$emit('SelectorPropertyValueChange', [reference, selectorPropertyEnum, value])
    },
    /**
     * @description This function will emit event to the selector builder
     * which signal it should add a selector to the selector that has this reference
     * the selector type is used to determine in which way the selector will be add to selector
     * @param {string} reference
     * @param {[import('../builder/selectorBuilder.js').SelectorTypeEnum]} selectorEnum
     * @param {[import('../builder/selectorBuilder.js').SelectorTypeEnum]} selectorType
     * @returns {void}
     */
    searchParentAddChild (reference, selectorEnum, selectorType) {
      this.$root.$emit('AddSelector', [reference, buildSelector(selectorEnum), selectorType])
    },
    /**
     * @description This function will emit event to the selector builder
     * which selector should displayed state should be toggled
     * @param {string} reference
     * @returns {void}
     */
    togleDisplay (reference) {
      this.$store.dispatch('set_display_selector_reference', { reference, display: !this.displayDetails })
    },
    /**
     * @description This function will emit event to the selector builder
     * which selector should hidden
     * @param {string} reference
     * @returns {void}
     */
    hideDisplay (reference) {
      this.$store.dispatch('set_display_selector_reference', { reference, display: false })
    },
  },
}
